// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","popup":"Modal_popup__KSYCg","close":"Modal_close__nnot4"};